import React from 'react';
import NHModal from '../../NHModal/index';
import EditForm from './EditForm';


class Link extends React.Component {
    static defaultProps = {

    }
    constructor(props) {
        super(props);
        this.state = {
            content: undefined,
            editor: undefined,
        };
    }
    componentDidMount() {
        this.initBtn();
    }
    componentWillUnmount() {

    }

    initBtn = () => {
        let obj = this;
        let UE = this.props.UE;
        UE.registerUI('nhLink nhUnlink', function (editor, uiName) {
            //注册按钮执行时的command命令，使用命令默认就会带有回退操作
            editor.registerCommand(uiName, {
                execCommand: function () {
                    alert('execCommand:' + uiName)
                }
            });
            //创建一个button
            var btn = new UE.ui.Button({
                //按钮的名字
                name: uiName,
                //提示
                title: uiName == 'nhLink' ? '超链接' : '取消链接',
                //添加额外样式，指定icon图标，这里默认使用一个重复的icon
                cssRules: uiName == 'nhLink' ? 'background-position: -500px 0;' : 'background-position: -640px 0;',
                //点击时执行的命令
                onclick: function () {
                    if (uiName == 'nhUnlink') {
                        editor.execCommand('unlink');
                    } else {
                        var range = editor.selection.getRange();
                        range.select();
                        var txt = editor.selection.getText();
                        if (txt) {
                            obj.setState({ content: txt, editor: editor }, () => {
                                obj.refs.nhModal.show();
                            });
                        }
                    }
                }
            });
            //当点到编辑内容上时，按钮要做的状态反射
            editor.addListener('selectionchange', function () {
                if (!me.getOpt('enableAutoSave')) {return;}
                var range = editor.selection.getRange();
                range.select();
                var txt = editor.selection.getText();
                if (txt) {
                    btn.setDisabled(false);
                } else {
                    btn.setDisabled(true);
                }
            });
            //因为你是添加button,所以需要返回这个button
            return btn;
        });
    }

    handleSave = (stopLoading) => {
        let obj = this;
        this.refs.nhForm.validateFields((err, formData) => {
            if (err) {
                stopLoading();
                return;
            }
            this.state.editor.execCommand('link', {
                href: formData.href,
                title: formData.title,
                content: formData.content,
                target: formData.target ? '_block' : '_self'
            });
            obj.refs.nhModal.close();
        });
    }

    render() {
        return (
            <div>
                <NHModal ref="nhModal"
                    title="超链接"
                    onOk={this.handleSave}
                >
                    <EditForm ref="nhForm" content={this.state.content} />
                </NHModal>
            </div>)
    }
}

export default Link;


// WEBPACK FOOTER //
// ./components/common/NHUeditor/link/index.js